import React, { Component, ReactNode } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

import FolderFilledIcon from '@atlaskit/icon/glyph/folder-filled';

import Path from 'src/components/path';
import SourceDirLink from 'src/components/source-dir-link';

import messages from './directory.i18n';
import * as styles from './directory.style';

// props could include path AND repositorySlug, or neither
type Props = {
  children?: ReactNode;
  className?: string;
  intl: InjectedIntl;
  path?: string | null | undefined;
  repositorySlug?: string;
};

export default injectIntl(
  class DirectoryPath extends Component<Props> {
    renderPath = () => {
      const { path, repositorySlug } = this.props;
      const segments = path ? [repositorySlug, ...path.split('/')] : ['/'];

      const wrappedSegments = segments.map((segment, i) => {
        const isFinal = i === segments.length - 1;
        const segmentPath = Array(segments.length - i).join('../');

        return isFinal ? (
          <styles.CurrentEntryPathSegment key={segmentPath}>
            {segment}
          </styles.CurrentEntryPathSegment>
        ) : (
          <styles.LinkedPathSegment key={segmentPath}>
            <SourceDirLink
              href={segmentPath || './'}
              onClick={e => e.stopPropagation()}
            >
              {segment}
            </SourceDirLink>
          </styles.LinkedPathSegment>
        );
      });

      return (
        <styles.PathWrapper>
          <Path>{wrappedSegments}</Path>
        </styles.PathWrapper>
      );
    };

    render() {
      return (
        <styles.PathHeader className={this.props.className}>
          <styles.IconWrapper>
            <FolderFilledIcon
              label={this.props.intl.formatMessage(messages.directoryIconLabel)}
            />
          </styles.IconWrapper>
          {this.renderPath()}
          {this.props.children}
        </styles.PathHeader>
      );
    }
  }
);
